import React from "react";
import { KeyValueList, NoData, Time } from "../../../../components";
import { NETWORK_THREAT_PATH } from "../../../../path";
import { StringWithCopy } from "../../../samples/components/report_summary/cards/common";
import NetworkLink from "../common/NetworkLink";

interface Props {
  domain?: string;
  ip?: string;
  lastAnalysisDate?: Date;
}

const NetworkHeaderAnalysis: React.FC<Props> = ({
  domain,
  ip,
  lastAnalysisDate
}) => (
  <div className="network-threat-intel__main-header-info">
    <KeyValueList className="flex flex-gap-5">
      <KeyValueList.Item
        label="Last Analyzed: "
        value={lastAnalysisDate ? <Time time={lastAnalysisDate} /> : <NoData />}
      />
      <KeyValueList.Item
        className="flex"
        label="Domain: "
        value={
          domain ? (
            <StringWithCopy value={domain} reverse>
              <NetworkLink
                className="basic-link-element"
                path={NETWORK_THREAT_PATH.DOMAIN_ANALYSIS}
              >
                {domain}
              </NetworkLink>
            </StringWithCopy>
          ) : (
            <NoData />
          )
        }
      />
      <KeyValueList.Item
        className="flex"
        label="IP: "
        value={
          ip ? (
            <StringWithCopy value={ip} reverse>
              <NetworkLink
                className="basic-link-element"
                path={NETWORK_THREAT_PATH.IP_ANALYSIS}
              >
                {ip}
              </NetworkLink>
            </StringWithCopy>
          ) : (
            <NoData />
          )
        }
      />
    </KeyValueList>
  </div>
);
export default NetworkHeaderAnalysis;
